import React from "react";

import { StatusBadgeProps } from "./statusBadgeProps";

export const HiredStatusBadge = (props: StatusBadgeProps) => {
    const { width, height = "18", viewBox = "0 0 45 18", ...rest } = props;

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox={viewBox}
            {...rest}
            data-cy="hiredBadge"
        >
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g transform="translate(-848.000000, -510.000000)">
                    <g transform="translate(828.000000, 241.000000)">
                        <g transform="translate(20.000000, 269.000000)">
                            <rect
                                fill="#6EEDB8"
                                x="0"
                                y="0"
                                width="45"
                                height="18"
                                rx="1.9656"
                            ></rect>
                            <path
                                d="M6.04268438,12.9656 L6.04268438,4.82870703 L7.28078203,4.82870703 L7.28078203,8.31841484 L11.0814539,8.31841484 L11.0814539,4.82870703 L12.3195516,4.82870703 L12.3195516,12.9656 L11.0814539,12.9656 L11.0814539,9.45861641 L7.28078203,9.45861641 L7.28078203,12.9656 L6.04268438,12.9656 Z M14.5769203,12.9656 L14.5769203,4.82870703 L15.815018,4.82870703 L15.815018,12.9656 L14.5769203,12.9656 Z M18.0781453,12.9656 L18.0781453,4.82870703 L20.5888922,4.82870703 C22.1264367,4.82870703 23.370293,5.68097891 23.370293,7.17821328 C23.370293,8.23203594 22.7022961,8.99792891 21.7348523,9.29161719 L23.9979797,12.9656 L22.5813656,12.9656 L20.5370648,9.41830625 C20.3815828,9.41830625 20.208825,9.42406484 20.0418258,9.42406484 L19.316243,9.42406484 L19.316243,12.9656 L18.0781453,12.9656 Z M19.3277602,8.41055234 L20.6983055,8.41055234 C21.6139219,8.38175937 22.1437125,7.93258906 22.1437125,7.20124766 C22.1437125,6.4238375 21.5563359,5.94011563 20.6004094,5.94011563 L19.3277602,5.94011563 L19.3277602,8.41055234 Z M25.368525,12.9656 L25.368525,4.82870703 L30.7528102,4.82870703 L30.7528102,5.96890859 L26.6066227,5.96890859 L26.6066227,8.31841484 L30.4188117,8.31841484 L30.4188117,9.45861641 L26.6066227,9.45861641 L26.6066227,11.7966055 L30.7528102,11.7966055 L30.7528102,12.9656 L25.368525,12.9656 Z M32.5955602,12.9656 L32.5955602,4.82870703 L34.8989977,4.82870703 C37.6458469,4.82870703 39.1085297,6.31442422 39.1085297,8.95761875 C39.1085297,11.4971586 37.6055367,12.9656 34.8874805,12.9656 L32.5955602,12.9656 Z M33.8336578,11.8253984 L34.7723086,11.8253984 C36.6899203,11.8253984 37.870432,11.0134367 37.870432,8.90579141 C37.870432,6.86149063 36.97785,5.96890859 34.8817219,5.96890859 L33.8336578,5.96890859 L33.8336578,11.8253984 Z"
                                fill="#210071"
                                fillRule="nonzero"
                            ></path>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};
